import React, { useRef } from "react";
import { FastField } from "formik";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { ExtraLabel } from "components";
import { StyledTextField } from "./FormikBirthdayPickerField.css";

interface FormikInputFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  extraLabel?: string;
  mask?: string;
}

export const FormikBirthdayPickerField = ({
  name,
  mask = "99/99/9999",
  label,
  disabled,
  extraLabel,
}: FormikInputFieldProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      {extraLabel && <ExtraLabel label={extraLabel} />}
      <FastField name={name}>
        {({ field, meta, form }: any) => {
          return (
            <InputMask
              {...field}
              mask={mask}
              onChange={field.onChange}
              name={field.name}
              disabled={disabled}
              autoComplete="off"
              onFocus={(event) => {
                event.target.select();
                inputRef?.current?.focus();
              }}
            >
              {() => (
                <StyledTextField
                  label={t(label)}
                  disabled={disabled}
                  size="small"
                  fullWidth
                  name={name}
                  error={!!form?.submitCount && Boolean(meta?.error)}
                  helperText={Boolean(form?.submitCount) && t(meta?.error)}
                  autoComplete="off"
                />
              )}
            </InputMask>
          );
        }}
      </FastField>
    </>
  );
};
